import http from "../http/http-config";
import { HealthCoverCapitalAndDescription } from "../models/healthCoverCapitalAndDescription";

export default new class getHealthCoverCapitalAndDescription {
    getHealthCoverCapitalAndDescription(productId, coverPercent, groupNumber, onDate, coverCode, moduleCode, correlationInformation, userName, userToken, tokenType): Promise<HealthCoverCapitalAndDescription[]> {
        return http.get<HealthCoverCapitalAndDescription[]>("GetHealthCoverCapitalAndDescription", {
            params: {
                productId,
                coverPercent,
                groupNumber,
                onDate,
                coverCode,
                moduleCode,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}
